// eslint-disable-next-line import/prefer-default-export
export enum SubscriptionStatus {
  ACTIVE = 'Active',
  ANNULLED = 'Annulled',
  CANCELLED = 'Cancelled',
  ENDED = 'Ended',
}
